import reasonsDialogCtrl from "./reasonsDialog/reasonsDialog.controller.js";
import reasonsDialogTemplate from "./reasonsDialog/reasonsDialog.html";

import startCase from "lodash/fp/startCase";
import each from "lodash/fp/each";
import { formatKey } from "../../core/utils";

class Controller {
  constructor(
    $stateParams,
    $mdDialog,
    Events,
    FulfillmentPlanTransforms,
    FulfillmentPlan,
    RescueReasons,
    Sections,
    City
  ) {
    "ngInject";

    this.fulfillmentPlanId = $stateParams.id;
    this.Events = Events;
    this.FulfillmentPlanTransforms = FulfillmentPlanTransforms;
    this.FulfillmentPlan = FulfillmentPlan;
    this.RescueReasons = RescueReasons;
    this.sections = Sections.plansSections;
    this.City = City;
    this.$mdDialog = $mdDialog;

    this.onUpdateEvent = this.Events.getUpdateEvent("fulfillmentPlan");
    this.successNotificationEvent = this.Events.eventsType.onShowSuccessNotification;
    this.errorNotificationEvent = this.Events.eventsType.onShowErrorNotification;

    this.deductionTypes = this.FulfillmentPlanTransforms.deductionTypes;
  }

  $onInit() {
    this.Events.on(this.onUpdateEvent, this.onUpdate.bind(this));

    this.RescueReasons.getAll({
      active: true,
      tag: ["captain", "partner", null],
    }).$promise.then(
      (response) => {
        this.deductionReasons = response.hits.map((reason) => ({
          ...reason,
          taken: {},
        }));
        this.getPlan();
      },
      (response) => {
        this.Events.emit(this.errorNotificationEvent, response.data);
      }
    );
  }

  getRideCategories(cityId) {
    this.City.getRideCategory({ city: cityId })
      .$promise.then((response) => {
        this.rideCategoryList = response.hits.map(({ _source }) => ({
          _id: _source._id,
          title: startCase(`${_source.ride_type} ${_source.service_type}`),
        }));
      })
      .catch((err) => this.Events.emit(this.errorNotificationEvent, err.data));
  }

  getPlan() {
    this.FulfillmentPlan.get(this.fulfillmentPlanId).$promise.then(
      (response) => {
        this.initPage(response);
        this.initTakenReasons();

        this.getRideCategories(response.city._id);
      },
      (response) => {
        this.Events.emit(this.errorNotificationEvent, response.data);
      }
    );
  }

  initPage(response) {
    this.fulfillmentPlan = this.FulfillmentPlanTransforms.justify(
      response,
      this.deductionReasons
    );
  }

  onUpdate(item) {
    const updatedItem = {
      [item.key]: item.value,
    };
    this.FulfillmentPlan.update(
      this.fulfillmentPlanId,
      updatedItem
    ).$promise.then(
      (response) => {
        this.toggleField(this.fulfillmentPlan[item.key]);
        this.initPage(response);
        this.Events.emit(this.successNotificationEvent, {
          message: `${formatKey(item.key)} is updated successfully`,
        });
      },
      (response) => {
        this.Events.emit(this.errorNotificationEvent, response.data);
      }
    );
  }

  toggleField(field) {
    field.isDisabled = !field.isDisabled;
  }

  // Deduction Rules
  addNewDeductionRule() {
    const newRule = {
      new: true,
      type: {},
      amount: "",
      time_before_ride: 0,
      reasons: [],
    };
    this.fulfillmentPlan.rules.push(newRule);
  }

  removeDeductionRule(index, form) {
    this.clearReasons(this.fulfillmentPlan.rules[index]);
    this.fulfillmentPlan.rules.splice(index, 1);
    if (!form.dirty) form.$setDirty();
  }

  updateDeductionRules() {
    const rules = this.FulfillmentPlanTransforms.justifyRulesRequest(
      this.fulfillmentPlan.rules
    );
    const item = {
      key: "rules",
      value: rules,
    };
    this.onUpdate(item);
  }

  handleRideCategoryChange(rule, oldValue) {
    if (oldValue) {
      this.clearReasons(rule, oldValue);
      rule.reasons.length = 0;
    }
  }

  // Reasons validation
  initTakenReasons() {
    this.fulfillmentPlan.rules.forEach((rule) => {
      const { reasons, ride_category: rideCategory } = rule;
      each((reason) => {
        if (rideCategory) {
          reason.taken[rideCategory] = true;
        }
      })(reasons);
    });
  }

  openReasonsDialog(rule, form) {
    const editReasonsModalObject = {
      controller: reasonsDialogCtrl,
      controllerAs: "$ctrl",
      template: reasonsDialogTemplate,
      bindToController: true,
      clickOutsideToClose: true,
      locals: {
        deductionReasons: this.deductionReasons,
        rule,
        form,
      },
    };

    this.$mdDialog.show(editReasonsModalObject);
  }

  clearReasons(rule, specificRideCategory) {
    const { reasons, ride_category: rideCategory } = rule;
    each((reason) => {
      reason.taken[specificRideCategory || rideCategory] = false;
    })(reasons);
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/fulfillmentPlan/fulfillmentPlan.controller.js